import 'css-chunksrc/client/scenes/comments/feed/log/styles.scss';export default {
  "log": "_log_17pws_1"
};